import React from 'react'

import { Layout } from '../components/Layout/Layout'
import { SEO } from '../components/Seo'
import { Hero } from '../components/Hero/Hero'
import { Technologies } from '../components/technologies'

const personSchema = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Talip Akçelik',
  url: 'https://talipakcelik.com/',
  sameAs: ['https://github.com/talipakcelik'],
}

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: 'https://talipakcelik.com/',
  inLanguage: 'tr',
  name: 'Talip Akçelik',
  description:
    'Talip Akçelik blog yazıları, akademik çalışmaları ve projeleri.',
}

const BlogIndex = () => (
  <Layout>
    <SEO
      title="Talip Akçelik | Blog, Akademik ve Projeler"
      description="Talip Akçelik blog yazıları, akademik çalışmaları ve projeleri."
      pathname="/"
      noTemplate
    />
    <script type="application/ld+json">
      {JSON.stringify(personSchema)}
    </script>
    <script type="application/ld+json">
      {JSON.stringify(websiteSchema)}
    </script>
    <Hero />
    <Technologies />
  </Layout>
)

export default BlogIndex
